<template>
	<div class="projectsList">
		<v-content>      
			<v-container fluid>
              <v-flex xs3>
                <div class="relative">
                  <a v-if="search != ''" @click.prevent="fncClearSearch" class="searchTypeClear"><i class="material-icons searchTypeClearText">close</i></a>
                  <v-text-field append-icon="search" label="Search" solo single-line v-model="search"></v-text-field><br />
                </div>                  
              </v-flex>
				<v-data-table :headers="headers" :search="search" :items="projectList" class="elevation-1" :rows-per-page-items="[20,40,60,80,100]">
					<template slot="items" slot-scope="props">
						<td width="25%" >{{ props.item.name }}</td>
						<td width="25%" >{{ props.item.code }}</td>
						<td width="15%" >{{ props.item.created }}</td>
						<td width="15%" >{{ props.item.modified }}</td>
						<td width="10%" v-if="objAuthorize.privileges.indexOf('CREATE_EDIT_DELETE_PROJECTS') !== -1" ><a @click.prevent="fncEditProject(props.item)"><i class="material-icons">edit</i></a></td>
						<td width="10%" v-if="objAuthorize.privileges.indexOf('CREATE_EDIT_DELETE_PROJECTS') !== -1" ><a @click.prevent="fncDeleteProject(props.item.id, props.item.name)"><i class="material-icons">delete</i></a></td>
					</template>
				</v-data-table>
			</v-container>
		</v-content>
	</div>
</template>

<script>

  import { mapGetters } from 'vuex';
  import Modal from '@/components/shared/modal';

  export default {
	name: 'PrivList',
    data () {
		return {
			search: '',
			headers: [
				{ text: 'Name', value: 'name', width: '25%' },
                { text: 'Code', value: 'code', width: '25%' },
                { text: 'Created On', value: 'created', width: '15%' },
                { text: 'Modified On', value: 'modified', width: '15%' },
                { text: 'Edit', value: 'edit', width: '10%' },
                { text: 'Delete', value: 'delete', width: '10%' }
			]
		}
	},
    methods: {
      fncClearSearch() {
        this.search = '';
      },
		fncDeleteProject(pid, pname) {
			var deleteProject = confirm('Are you sure you want to delete '+pname+'?');
			if(deleteProject === true) {
				this.$store.dispatch({
					type: 'fncDeleteProject',
					projectId: pid
				})
			}
		},
        fncEditProject(objProject) {
          this.$store.dispatch('fncPopulateProjectPreLocations');
          this.$store.dispatch('fncSetProjectEdit', objProject);          
			/*this.$store.dispatch({
				type: 'fncLockPricelist',
				obj: objPricelist
			});
			var modalDetails = { title: 'Edit Project', component: 'modal-project-edit', mstate: true, params: {} };
			this.$store.commit({
				type: 'setModal',
				details: modalDetails
			});*/
		}
	},
	computed: {
		...mapGetters([
			'objAuthorize',
			'projectList',
		])
	},
	beforeMount() {
		this.$store.dispatch('fncPopulateProjectList');
	},
	created() {
		if( this.objAuthorize.privileges.indexOf('CREATE_EDIT_DELETE_PROJECTS') === -1 ) {
			this.headers = [
                { text: 'Name', value: 'name' },
                { text: 'Code', value: 'code' },
                { text: 'Created On', value: 'created_on' },
                { text: 'Modified On', value: 'modified_on' },
			]
		}
	}
}
</script>

<style scoped>

</style>